const AUTOMATIC_CONNECT_NOT_PRESENT = -1;
const AUTOMATIC_CONNECT_FALSE = 0;
const AUTOMATIC_CONNECT_TRUE = 1;

const TAX_DISPLAY_TYPE_EXCL_TAX = 1;
const TAX_DISPLAY_TYPE_INCL_TAX = 2;
const TAX_DISPLAY_TYPE_BOTH = 3;

const MIME_TYPES = {
  PDF: { type: ["application/pdf"], image: "" },
  JPG: { type: ["image/jpg"], image: "" },
  JPEG: { type: ["image/jpeg"], image: "" },
  GIF: { type: ["image/gif"], image: "" },
  XLS: { type: ["application/vnd.ms-excel"], image: "" },
  XLSX: {
    type: ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
    image: ""
  },
  INDD: {
    type: ["application/x-adobe-indesign", "application/x-indesign", ".indd"],
    image: ""
  },
  AI: { type: ["application/postscript"], image: "" },
  PSD: { type: ["image/vnd.adobe.photoshop", ".psd"], image: "" },
  PNG: { type: ["image/png"], image: "" },
  TIFF: { type: ["image/tiff"], image: "" },
  TIF: { type: ["image/tif"], image: "" },
  DOC: { type: ["application/msword"], image: "" },
  DOCX: {
    type: [
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ],
    image: ""
  },
  ZIP: { type: ["application/zip", "application/x-zip-compressed"], image: "" },
  RAR: {
    type: ["application/x-rar-compressed", "application/vnd.rar", ".rar"],
    image: ""
  }
};

export default {
  AUTOMATIC_CONNECT_NOT_PRESENT,
  AUTOMATIC_CONNECT_FALSE,
  AUTOMATIC_CONNECT_TRUE,
  MIME_TYPES,
  TAX_DISPLAY_TYPE_EXCL_TAX,
  TAX_DISPLAY_TYPE_INCL_TAX,
  TAX_DISPLAY_TYPE_BOTH
};
